import React, { useEffect } from 'react'
import "./Term&Cond.css"
import JoinRibbon from '../../components/JoinRibbon'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import Navbar from '../../Layout/NavBar'
import FAQSection from '../LandingPage/FAQ_Section'
import TestimonialSection from '../LandingPage/testimonialSection/TestimonialSection'

function TermAndCond() {
    const navigate = useNavigate()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    return (
        <div className='termAndCond-page'>
            <Navbar type={1}  />

            <div className='tnc-content-wp'>
                <h1>Term and Condition</h1>
                <div className='tnc-wp'>

                    <p className='tnc-desc'>Welcome to DSA Simplified! By accessing and using our program, you agree to the following Terms & Conditions. Please read them carefully, as they outline the obligations, rights, and limitations for both you (the user) and us (the service provider).</p>
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Introduction</h4>
                    <p className='tnc-desc'>DSA Simplified (this website) is a platform that provides a curated list of publicly available resources such as blogs, videos, and Telegram links to help users access useful content in a structured manner.</p>
                    <p>By using our website, you agree to these Terms and Conditions and our Privacy Policy.</p>
                </div>


                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Use of Services</h4>
                    <p className='tnc-desc'>Our website only provides links to publicly available resources. We do not host, own, or control the content of these resources.</p>
                    <p>The use of the linked content is subject to the terms and conditions of the respective websites or platforms.</p>
                </div>


                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Intellectual Property</h4>
                    <p className='tnc-desc'>All linked content, trademarks, logos, and materials belong to their respective owners.</p>
                    <p>We do not claim ownership of any content provided through external links.</p>
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Payments and Refunds</h4>
                    <p className='tnc-desc'>Access to our curated list of resources is provided as a paid service.</p>
                    <p>Payments are non-refundable except in cases where we fail to deliver the promised service.</p>
                    <p>If you have any payment-related concerns, please contact us at [dsasimplified.info@gmail.com].</p>
                </div>


                <div className='tnc-wp'>
                    <h4 className='tnc-header'>User Responsibilities</h4>
                    <p className='tnc-desc'>Users must ensure they use our website and linked resources in compliance with all applicable laws and regulations.</p>
                    <p>We are not responsible for any issues arising from the misuse of external links.</p>
                </div>


                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Limitation of Liability</h4>
                    <p className='tnc-desc'>We are not responsible for:</p>
                    <p>We are not responsible for any issues arising from the misuse of external links.</p>
                    <ul className='list-wp'>
                        <li>
                            <div>
                                <p className='rp-desc'>The accuracy, reliability, or completeness of the linked resources.</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <p className='rp-desc'>Any issues related to third-party content, including copyright disputes or data privacy concerns.</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <p className='rp-desc'>Any loss or damage incurred while using the links or third-party websites.</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Privacy Policy</h4>
                    <p className='tnc-desc'>We are committed to protecting your privacy. Any personal information collected (e.g., during payments) will be handled as per our Privacy Policy.</p>
                    <p>We do not sell or share user data with third parties without consent.</p>   
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Content Updates and Removal</h4>
                    <p className='tnc-desc'>We reserve the right to update or remove any links or content from our platform at any time without prior notice.</p>
                    <p>These Terms and Conditions may also be updated periodically. Continued use of the website constitutes acceptance of the revised terms.</p>   
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Links to Third-Party Websites</h4>
                    <p className='tnc-desc'>Our website contains links to third-party websites, including blogs, videos, and Telegram groups.</p>
                    <p>We are not responsible for the content, privacy policies, or practices of these third-party websites.</p>   
                    <p>Users are advised to review the terms and privacy policies of external websites before using their services.</p>
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Charges for Curation</h4>
                    <p className='tnc-desc'>The fees charged on our platform are for the service of curating, organizing, and presenting publicly available resources in a structured manner for user convenience.</p>
                    <p>We do not charge for the content of third-party resources or websites, which remain freely accessible through their original platforms.</p>   
                    
                </div>


                <div className='tnc-wp'>
                    <h4 className='tnc-header'>General Inquiries</h4>
                    <p className='tnc-desc'>For general questions or information about our program and services, email us at:</p>
                    <p>Email: [inquiry@dsasimplified.com]</p>
                    <p>WhatsApp: <Link to={"https://wa.me/" + process.env.REACT_APP_CONTACT_NUM}>Click</Link></p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Technical Support</h4>
                    <p className='tnc-desc'>If you’re experiencing technical issues accessing the program or specific content, our support team is here to help:</p>
                    <p>Email: [support@dsasimplified.com]</p>
                    <p>Response Time: Typically within 24-48 hours</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Billing and Refunds</h4>
                    <p className='tnc-desc'>For questions related to payments or refund requests, please contact:</p>
                    <p>Email: [billing@dsasimplified.com]</p>
                    <p>Response Time: Typically within 3-5 business days</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Feedback and Suggestions</h4>
                    <p className='tnc-desc'>Your feedback helps us improve! If you have ideas, suggestions, or want to share your success story, we’d love to hear from you:</p>
                    <p>Email: [feedback@dsasimplified.com]</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Business Hours</h4>
                    <p className='tnc-desc'>Our team is available to respond to inquiries during the following hours:</p>
                    <p>Monday to Friday: 9:00 AM - 6:00 PM (IST)</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Connect with Us on Social Media</h4>
                    <p className='tnc-desc'>Stay updated on program enhancements, new resources, and more by following us on social media:</p>
                    {/* <p>[Link to social media profiles, if applicable --xxxxx]</p> */}
                    <p>We look forward to helping you excel in your tech interview preparation and are committed to providing prompt, high-quality support.</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Intellectual Property</h4>
                    <p>All content provided on our website, including course materials, is the intellectual property of our business. You may not reproduce, distribute, or use any content without our prior written permission.</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>User Responsibilities</h4>
                    <p className='tnc-desc'>Users must ensure that all information provided during registration and payment is accurate and up to date.</p>
                    <p>Users are responsible for maintaining the confidentiality of their account information and for all activities that occur under their account.</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Limitation of Liability</h4>
                    <p className='tnc-desc'>Our business will not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with the use of our services.</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Governing Law</h4>
                    <p className='tnc-desc'>These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which our business operates.</p>
                </div>
                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Changes to Terms and Conditions</h4>
                    <p className='tnc-desc'>We reserve the right to modify these terms and conditions at any time. Any changes will be posted on our website, and it is your responsibility to review them periodically.</p>
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Contact Us</h4>
                    <p className='tnc-desc'>For any questions or concerns regarding these Terms & Conditions, please reach out to us at</p>
                    <Link to={"/contact"}><p>Contact us page, click to visit</p></Link>
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Use License</h4>
                    <p className='tnc-desc'>Permission is granted to temporarily download one copy of any downloadable materials on the website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
                    <ul className='list-wp'>

                        <li>
                            <div>
                                <p className='rp-desc'>attempt to decompile or reverse engineer any software contained on the our web site</p>
                            </div>
                        </li>

                        <li>
                            <div>
                                <p className='rp-desc'>remove any copyright or other proprietary notations from the materials</p>
                            </div>
                        </li>

                        <li>
                            <div>
                                <p className='rp-desc'>transfer the materials to another person or 'mirror' the materials on any other server.</p>
                            </div>
                        </li>
                    </ul>

                    <p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Company at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</p>

                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Limitations</h4>
                    <p className='tnc-desc'>In no event shall the School be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the School’s website, even if the School or an authorized of the School has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>
                    
                </div>


                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Limitations</h4>
                    <p className='tnc-desc'>The materials appearing on the website may include technical, typographical, or photographic errors. We does not warrant that any of the materials on its web site are accurate, complete, or current. We may make changes to the materials contained on its web site at any time without notice. The We does not, however, make any commitment to update the materials.</p>
                    
                </div>

                <div className='tnc-wp'>
                    <h4 className='tnc-header'>Links</h4>
                    <p className='tnc-desc'>The we has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by the School of the site. Use of any such linked website is at the user's own risk.</p>
                    
                </div>



            </div>
            <FAQSection />
            <TestimonialSection />
            <JoinRibbon />
        </div>
    )
}

export default TermAndCond